import { fromJS } from 'immutable';
import { Reducer } from 'redux';

import Organization from 'entities/organization/model';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SET_FETCH_PARAMS,
  FETCH_FAILED,
  FETCH_DONATIONS_TOTAL,
  FETCH_DONATIONS_TOTAL_SUCCESS,
  FETCH_DONATIONS_TOTAL_FAILED,
  FETCH_DEEDS_TOTAL,
  FETCH_DEEDS_TOTAL_SUCCESS,
  FETCH_DEEDS_TOTAL_FAILED,
  FETCH_VOLUNTEERHOURS_TOTAL,
  FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS,
  FETCH_VOLUNTEERHOURS_TOTAL_FAILED,
  FETCH_PARTNERS,
  FETCH_PARTNERS_SUCCESS,
  FETCH_PARTNERS_FAILED,
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAILED,
  DELETE_PARTNER,
  DELETE_PARTNER_SUCCESS,
  DELETE_PARTNER_FAILED,
} from './types';

export const initialState = fromJS({
  loading: false,
  error: false,
  fetchParams: {
    id: null,
    search: '',
    pageNum: 0,
    limit: 10,
  },
  organization: null,
  initialized: false,
  totals: {
    donationsTotal: { total: null, loading: false },
    deedsTotal: { total: null, loading: false },
    volunteerHoursTotal: { total: null, loading: false },
  },
});

export default (
  state = initialState,
  action: {
    type: string;
    error?: Error;
    params?: any;
    organization?: Organization;
    donationsTotal: number;
    deedsTotal: number;
    volunteerHoursTotal: number;
  }
): Reducer => {
  switch (action.type) {
    case INIT:
      return state.merge({
        loading: true,
        fetchParams: initialState.get('fetchParams').merge({ ...action.params }),
        initialized: false,
      });

    case SET_FETCH_PARAMS:
      return state.merge({
        loading: true,
        fetchParams: state.get('fetchParams').merge({ pageNum: 0, ...action.params }),
      });

    case FETCH_DONATIONS_TOTAL:
      return state.setIn(['totals', 'donationsTotal', 'loading'], true);

    case FETCH_DONATIONS_TOTAL_SUCCESS:
      return state
        .setIn(['totals', 'donationsTotal', 'loading'], false)
        .setIn(['totals', 'donationsTotal', 'total'], action.donationsTotal);

    case FETCH_DONATIONS_TOTAL_FAILED:
      return state
        .setIn(['totals', 'donationsTotal', 'loading'], false)
        .setIn(['totals', 'error'], action.error);

    case FETCH_DEEDS_TOTAL:
      return state.setIn(['totals', 'deedsTotal', 'loading'], true);

    case FETCH_DEEDS_TOTAL_SUCCESS:
      return state
        .setIn(['totals', 'deedsTotal', 'loading'], false)
        .setIn(['totals', 'deedsTotal', 'total'], action.deedsTotal);

    case FETCH_DEEDS_TOTAL_FAILED:
      return state
        .setIn(['totals', 'deedsTotal', 'loading'], false)
        .setIn(['totals', 'error'], action.error);

    case FETCH_VOLUNTEERHOURS_TOTAL:
      return state.setIn(['totals', 'volunteerHoursTotal', 'loading'], true);

    case FETCH_VOLUNTEERHOURS_TOTAL_SUCCESS:
      return state
        .setIn(['totals', 'volunteerHoursTotal', 'loading'], false)
        .setIn(['totals', 'volunteerHoursTotal', 'total'], action.volunteerHoursTotal);

    case FETCH_VOLUNTEERHOURS_TOTAL_FAILED:
      return state
        .setIn(['totals', 'volunteerHoursTotal', 'loading'], false)
        .setIn(['totals', 'error'], action.error);

    case INIT_SUCCESS:
      return state.merge({
        loading: false,
        organization: action.organization,
        initialized: true,
      });

    case INIT_FAILED:
    case FETCH_FAILED:
      return state.merge({
        loading: false,
        error: action.error,
        initialized: true,
      });

    case FETCH_PARTNERS:
      return state.set('partnersLoading', true);

    case FETCH_PARTNERS_SUCCESS:
    case FETCH_PARTNERS_FAILED:
      return state.set('partnersLoading', false);

    case CREATE_PARTNER:
      return state.set('partnerSubmitting', true);

    case CREATE_PARTNER_SUCCESS:
    case CREATE_PARTNER_FAILED:
      return state.set('partnerSubmitting', false);

    case DELETE_PARTNER:
      return state.set('partnerDeleting', true);

    case DELETE_PARTNER_SUCCESS:
    case DELETE_PARTNER_FAILED:
      return state.set('partnerDeleting', false);

    default:
      return state;
  }
};
